export const commonFunctionEngBot = (englishBot, value, data) => {
  if (englishBot) {
    return value;
  }
  return data;
};
